
import React, { useState } from "react";
import {
  Box,
  Button,
  TextField,
  InputAdornment,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import Select, { components } from "react-select";
import { useNavigate } from "react-router-dom";

/* 
   Custom MultiValue
*/
const CustomMultiValue = ({ index, getValue, ...props }) => {
  const maxToShow =1;
  const selected = getValue();
  const extraCount = selected.length - maxToShow;

  // Show first 1 chips normally
  if (index < maxToShow) {
    return <components.MultiValue {...props} />;
  }

  // Show +N only once
  if (index === maxToShow) {
    return (
      <div
        style={{
          background: "#C7DD94",
          borderRadius: 12,
          padding: "2px 8px",
          fontSize: 12,
          fontWeight: 600,
          marginLeft: 4,
          color: "#111",
        }}
      >
        +{extraCount}
      </div>
    );
  }

  return null;
};

export default function BannerSearch({
  locations = ["New York", "Los Angeles", "Chicago", "Chennai", "Mumbai", "Delhi"],
  type = "all",
}) {
  const [selectedLocations, setSelectedLocations] = useState([]);
  const [searchInput, setSearchInput] = useState("");
  const navigate = useNavigate();

  const handleSearch = () => {
    if (!searchInput.trim()) return;
    navigate(`/search?q=${encodeURIComponent(searchInput.trim())}&property_type=${type}`);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") handleSearch();
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: { xs: "column", sm: "row" },
        flexWrap: { xs: "wrap", sm: "nowrap" },
        alignItems: "center",
        gap: 1,
        backgroundColor: "#f5f5f5",
        p: { xs:0.8, sm: 1, md: 1 },
        borderRadius: { xs: "10px", sm: "40px", md: "40px" },
        width: "100%",
      }}>
      {/* Location Select */}
      {/* <Box sx={{ flex: 2, minWidth: { xs: "100%", sm: 200, md: 250, lg: 250 } }}>
        <Select
          options={locations.map((loc) => ({
            value: loc,
            label: loc,
          }))}
          value={selectedLocations.map((loc) => ({
            value: loc,
            label: loc,
          }))}
          onChange={(selected) => {
            if (selected) {
              setSelectedLocations(selected.map((s) => s.value));
            } else {
              setSelectedLocations([]);
            }
          }}
          isMulti
          placeholder="Select Location"
          closeMenuOnSelect={false}
          hideSelectedOptions={false}
          components={{
            MultiValue: CustomMultiValue,
            DropdownIndicator: () => (
              <img
                src="/assets/icons/location.png"
                alt="location"
                style={{ width: 18, height: 18, marginRight: 4 }}
              />
            ),
            IndicatorSeparator: () => null,
          }}
          styles={{
            control: (provided) => ({
              ...provided,
              minHeight: 36,
              borderRadius: 20,
              backgroundColor: "transparent",
              display: "flex",
              alignItems: "center",
              paddingLeft: 8,
              border: "none",
              boxShadow: "none",
              "&:hover": { border: "none" },
            }),
            menu: (provided) => ({
              ...provided,
              backgroundColor: "#fff",
              color: "#000",
              borderRadius: 10,
            }),
            option: (provided, state) => ({
              ...provided,
              backgroundColor: state.isFocused ? "#C7DD94" : "#fff",
              color: "#000",
              cursor: "pointer",
            }),
            multiValue: (provided) => ({
              ...provided,
              backgroundColor: "#C7DD94",
            }),
            multiValueLabel: (provided) => ({
              ...provided,
              color: "#111",
              fontWeight: 600,
            }),
            multiValueRemove: (provided) => ({
              ...provided,
              color: "#111",
              ":hover": { backgroundColor: "#C7DD94", color: "#111" },
            }),
            placeholder: (provided) => ({
              ...provided,
              color: "#999",
              marginLeft: 0,
            }),
            valueContainer: (provided) => ({
              ...provided,
              display: "flex",
              alignItems: "center",
              flexWrap: "wrap",
            }),
          }}
        />
      </Box> */}

      {/* Divider */}
      {/* <Box
        sx={{
          display: { xs: "none", sm: "flex" },
          alignItems: "center",
          mx: 0.5,
        }}
      >
        <Box sx={{ width: 2, height: 20, bgcolor: "#D5D5D5", borderRadius: 1 }} />
      </Box> */}

      {/* Search Input */}
      <Box sx={{ flex: 2, minWidth: { xs: "100%", sm: 150, md: 250, lg: 250 } }}>
        <TextField
          fullWidth
          size="small"
          placeholder='Search your property...'
          variant="outlined"
          value={searchInput}
          onChange={(e) => setSearchInput(e.target.value)}
          onKeyDown={handleKeyDown}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon fontSize="small" />
              </InputAdornment>
            ),
            sx: {
              borderRadius: { xs: "10px", sm: "20px", md: "20px" },
              height: 36,
              paddingRight: 1,
              "& .MuiOutlinedInput-notchedOutline": { border: "none" },
              "&:hover .MuiOutlinedInput-notchedOutline": { border: "none" },
              "&.Mui-focused .MuiOutlinedInput-notchedOutline": { border: "none" },
              "& input::placeholder": {
                fontSize: "14px",
                opacity: 0.7,
              },
            },
          }}
        />
      </Box>

      {/* Divider */}
      <Box
        sx={{
          display: { xs: "none", sm: "flex" },
          alignItems: "center",
          mx: 0.5,
        }}
      >
        <Box sx={{ width: 2, height: 20, bgcolor: "#D5D5D5", borderRadius: 1 }} />
      </Box>

      {/* Search Button */}
      <Box
        sx={{
       
          width: { xs:"100%", sm: 100, md:250,lg:250},
          display: "flex",
          justifyContent: "center",
          mt: { xs: 1, sm: 0 },
        }}
      >
        <Button
          variant="contained"
          onClick={handleSearch}
          sx={{
            borderRadius: "9999px",
            px: 3,
            py: 1,
            textTransform: "none",
            width: "100%",
            minHeight: 36,
            backgroundColor: "#9EB86D",
            color: "#111",
            "&:hover": { backgroundColor: "#9EB86D" },
          }}>
          Search
        </Button>
      </Box>
    </Box>
  );
}
